import { ReduxState } from 'src/store/types';

// prevState must be typed as `any` since it's an older version of the Redux State
export const v0 = (prevState: any): ReduxState => prevState;
